<template>
  <div class="terms-of-service">
    <h2>Terms of Use</h2>
    <md-tabs md-sync-route>
      <md-tab id="tab-general" md-label="General" to="/terms">
        <div v-html="$t('company.GENERAL_BODY')"/>
      </md-tab>

      <md-tab id="tab-domains" md-label="Domain Names" to="/terms/domains">
        <div v-html="$t('company.DOMAINS_BODY')"/>
      </md-tab>
    </md-tabs>


  </div>
</template>

<script>
import style from 'styles/terms-of-service.scss'
export default {
  name: 'terms-of-service',
  data () {
    return {

    }
  }
}
</script>

